<template>
	<div class="app-wrapper">
  		<!--头部-->
  		<my-header @sendHeight="getHeadHeight"></my-header>
		<!--头部 END-->
			
		<!--内容区域-->
		<!--<div :style="{height:mianHeight+'px'}" :class="[isMin?'main-right-min':'main-right-max','main-right']">-->
		<div>
			<div style="height: 90.8%;">
				<app-main></app-main>
			</div>
		</div>
		<!--内容区域 END-->
		
		<!--底部-->
  		<my-footer ></my-footer>
		<!--头部 END-->
		
  	</div>
</template>

<script>
import MyHeader from './components/Header'
import MyFooter from './components/Footer'
import Sidebar from './components/Sidebar'
import AppMain from './components/AppMain'
import TagsView from './components/TagsView'
export default{
	name:'Index',
	beforeCreate () {
	  document.querySelector('body').setAttribute('style', 'margin: 0;');
	},
	components: {
		MyHeader,
		MyFooter,
		Sidebar,
		AppMain,
		TagsView
	},
	data () {
	    return {
			isMin:false,
			mianHeight:0
	    }
	},
	methods: {
		getHeadHeight(headHeight){
			var clientHeight=0;
			if(document.body.clientHeight&&document.documentElement.clientHeight){
				clientHeight = (document.body.clientHeight<document.documentElement.clientHeight)?document.body.clientHeight:document.documentElement.clientHeight;
			}
			else{
				clientHeight = (document.body.clientHeight>document.documentElement.clientHeight)?document.body.clientHeight:document.documentElement.clientHeight;
			}
			let curHeight = clientHeight - headHeight.replace("px","")
			this.mianHeight = curHeight > 550 ? curHeight:550
		},
		isShowMin(){
			this.isMin = !this.isMin
		},
	    logout(){
	    	this.$store.dispatch('Logout').then(() => {
	            this.$router.push({ path: '/login' });
	        }).catch(err => {
	            this.$message.error(err);
	        });
	    }
	},
	mounted(){
	}
}
</script>
<style lang="scss" scoped>
	.app-wrapper{
		width: 100%;
		min-width: 1295;
		background:rgba(244,248,255,1);
	}
	.main-right{
		position: absolute;
		top: 80px;
		// height: 852px;
		// padding: 18px;
		z-index: -1;
		background:rgba(244,248,255,1);
		box-shadow: 0px 2px 10px 0px rgba(124,130,140,0.15);
		-webkit-box-shadow: 0px 2px 10px 0px rgba(124,130,140,0.15);
		-moz-box-shadow: 0px 2px 10px 0px rgba(124,130,140,0.15);
	}
	.main-right-max{
		width: 1690px;
		margin-left: 230px;
	}
	.main-right-min{
		width: 1830px;
		margin-left: 90px;
	}
</style>


// WEBPACK FOOTER //
// src/layout/Layout.vue